module.exports = __webpack_public_path__ + "img/1.2a735198.png";